import moment from 'moment';
import React from 'react';
import { useMutation, useQuery } from 'react-apollo';
import DatePicker from "react-datepicker";
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { OperatingUsers, Operator } from '../../assets/scss/role.constant';
import { RECALCULATE_WALLET_BALANCE, UPDATE_ONE_WALLET } from '../../graphql/mutation';
import { FIND_OR_CREATE_AGENT_WALLET } from '../../graphql/mutation/FIND_OR_CREATE_AGENT_WALLET';
import { ME } from '../../graphql/query';
import ToastHelper from '../../helpers/ToastHelper';

function AgentWalletView(props) {
    const { player, onMovement, onUpdateWalletId, onRefetch, onRefetchComplete } = props

    const [isEditDate, setIsEditDate] = React.useState(false)

    const [getAgentWallet, { data, loading }] = useMutation(FIND_OR_CREATE_AGENT_WALLET, {
        variables: {
            userId: player.id
        }
    })

    const { data: meData } = useQuery(ME, {
        fetchPolicy: 'cache-first'
    })

    const [recalculateWalletBalance, { loading: loadingBalance }] = useMutation(RECALCULATE_WALLET_BALANCE)
    const [updateOneWallet] = useMutation(UPDATE_ONE_WALLET)

    React.useEffect(() => {
        getAgentWallet()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        if (onRefetch === 'agent') {
            getAgentWallet().then(() => {
                onRefetchComplete()
            })
        }
    }, [onRefetch]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <React.Fragment>
            {
                loading &&
                <div className="text-center mb-3">
                    <Link to="#" className="text-success"><i className="bx bx-hourglass bx-spin mr-2"></i> Loading</Link>
                </div>
            }
            {
                !loading &&
                data &&
                <div className="stat-component">
                    <div className="border p-3 rounded">
                        <div className="d-flex align-items-center mb-1">
                            <div className="avatar-xs mr-3">
                                <span className="avatar-title rounded-circle bg-soft-primary text-primary font-size-18 cursor-pointer" onClick={() => {
                                    let path = `wallet-details/${player.id}/${data.findOrCreateAgentCreditWallet.id}`
                                    window.open(path, "_blank")
                                }}>
                                    <i className="bx bx-network-chart"></i>
                                </span>
                            </div>
                            <div>
                                <p className="mb-1">Agent Wallet</p>
                                <h5>{parseFloat(data.findOrCreateAgentCreditWallet.balance).toFixed(2)}AP</h5>
                            </div>
                        </div>
                        <div className="text-muted mt-2">
                            <p className="mb-1">Expired At</p>
                            <h5>{moment(data.findOrCreateAgentCreditWallet.expiredAt).format('YYYY-MM-DD')} {moment(data.findOrCreateAgentCreditWallet.expiredAt).diff(moment(), 'days') >= 0 ? `(${moment(data.findOrCreateAgentCreditWallet.expiredAt).diff(moment(), 'days')} days left)` : '(Expired)'}  <i className="bx bxs-edit cursor-pointer font-size-18 align-middle ml-2" onClick={() => setIsEditDate(!isEditDate)}></i> </h5>
                            {
                                isEditDate &&
                                <div className="wallet-date-picker">
                                    <DatePicker
                                        onChange={date => {
                                            setIsEditDate(false)

                                            updateOneWallet({
                                                variables: {
                                                    input: {
                                                        update: {
                                                            expiredAt: `${moment(date).format('YYYY-MM-DD')}T15:59:59.999Z`
                                                        },
                                                        id: data.findOrCreateAgentCreditWallet.id
                                                    }
                                                }
                                            }).catch(e => {
                                                ToastHelper.toggleToast({
                                                    toastType: "error",
                                                    message: e,
                                                    title: "",
                                                    onClick: function () { }
                                                })
                                            }).then(val => {
                                                if (val) {
                                                    ToastHelper.toggleToast({
                                                        message: "Update Succesfully!",
                                                        title: "",
                                                        onClick: function () { }
                                                    })
                                                }

                                                getAgentWallet()
                                            })
                                        }}
                                        selectsStart
                                        inline
                                    />
                                </div>
                            }
                        </div>
                        <div className="text-muted mt-2">
                            <p className="mb-1">Actions</p>
                            <div className="align-center">
                                <button className="btn btn-primary waves-effect waves-light font-size-14 action-button btn-sm" onClick={() => {
                                    recalculateWalletBalance({
                                        variables: {
                                            id: data.findOrCreateAgentCreditWallet.id
                                        }
                                    })
                                }}>
                                    {
                                        !loadingBalance &&
                                        <i className="bx bx-sync font-size-14"></i>
                                    }
                                    {
                                        loadingBalance &&
                                        <i className="fas fa-spinner fa-pulse font-size-13"></i>
                                    }
                                </button>
                                {
                                    meData &&
                                    !OperatingUsers.includes(meData.me.role) &&
                                    !Operator.includes(meData.me.role) &&
                                    <>
                                        <div className="mr-2"></div>
                                        <button className="btn btn-primary font-size-14 btn-sm" onClick={() => {
                                            onUpdateWalletId(data.findOrCreateAgentCreditWallet.id)
                                            onMovement('APGenerated')
                                        }}>
                                            <i className="bx bx-plus"></i>
                                        </button>
                                    </>
                                }
                                {
                                    meData &&
                                    !OperatingUsers.includes(meData.me.role) &&
                                    !Operator.includes(meData.me.role) &&
                                    <>
                                        <div className="mr-2"></div>
                                        <button className="btn btn-primary font-size-14 btn-sm" onClick={() => {
                                            onUpdateWalletId(data.findOrCreateAgentCreditWallet.id)
                                            onMovement('APVoided')
                                        }}>
                                            <i className="bx bx-minus"></i>
                                        </button>
                                    </>
                                }
                            </div>
                        </div>
                        <div className="text-muted mt-3 action-container">
                            <Link to={`wallet-details/${player.id}/${data.findOrCreateAgentCreditWallet.id}`} target="_blank" className="btn btn-primary btn-sm">View more <i className="mdi mdi-arrow-right ml-1"></i></Link>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}

export default connect()(withTranslation()(AgentWalletView));